<template>
  <div :class="$style.gamesCatalogueSliderHeader">
    <p v-if="headerText" :class="$style.gamesCatalogueSliderTitle">
      <span>{{ headerText }}</span>
    </p>
    <p v-else :class="$style.gamesCatalogueSliderTitle">
      <img v-if="icon" :src="icon" alt="" height="24" width="24" />
      <span>{{ replaceSlotsToPokiesIfNeeded(name) }}</span>
    </p>
    <div v-if="!isLoading" :class="$style.gamesCatalogueSliderNav">
      <a
        v-if="!noShowAllButton"
        :href="showAllLink"
        :class="$style.gamesCatalogueSliderNavShowAll"
        @click.prevent="$emit('showAll')"
      >
        <BitTabButton>
          {{ showAllTitle }}
        </BitTabButton>
      </a>

      <div
        v-if="!$slots.navButtons"
        v-show="!noNavigation"
        ref="sliderNavButtonsRef"
        :class="[$style.gamesCatalogueSliderNavButtons, { [$style.isNoNavigation]: noNavigation }]"
      >
        <div
          class="flicking-arrow-prev"
          :class="$style.gamesCatalogueSliderNavButton"
          aria-label="Previous"
        >
          <BitNavArrowButton direction="left" :disabled="isLoading" />
        </div>
        <div
          class="flicking-arrow-next"
          :class="$style.gamesCatalogueSliderNavButton"
          aria-label="Next"
        >
          <BitNavArrowButton :disabled="isLoading" />
        </div>
      </div>
      <div v-else ref="sliderNavButtonsRef" :class="$style.gamesCatalogueSliderNavButtons">
        <slot name="navButtons" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitTabButton, BitNavArrowButton } from '@bit/ui-kit';
import { useTextReplacements } from '~/composables/useTextReplacements';

defineProps({
  headerText: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  showAllTitle: {
    type: String,
    default: '',
  },
  noNavigation: {
    type: Boolean,
    default: false,
  },
  noShowAllButton: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  showAllLink: {
    type: String,
    default: '',
  },
});
defineEmits<{
  (e: 'showAll'): void;
}>();

const textReplacements = useTextReplacements();

const replaceSlotsToPokiesIfNeeded = textReplacements.replaceSlotsToPokiesIfNeeded;
</script>

<style lang="scss" module src="./catalogueSliderHeader.scss"></style>
